const QUEUE_KEY = "gsm_offline_queue";
const QUEUEABLE_PATHS = ["/scores/save", "/scores/clear"];

function readQueue() {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeQueue(queue) {
  try {
    localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
  } catch (e) {
    console.error("Failed to persist offline queue:", e);
  }
  changeListeners.forEach(fn => fn(queue.length));
}

let changeListeners = [];
export function onQueueChange(fn) {
  changeListeners.push(fn);
  return () => { changeListeners = changeListeners.filter(l => l !== fn); };
}

let failureListeners = [];
export function onQueueItemFailed(fn) {
  failureListeners.push(fn);
  return () => { failureListeners = failureListeners.filter(l => l !== fn); };
}

export function isQueueablePath(url) {
  return typeof url === "string" && QUEUEABLE_PATHS.some(p => url.includes(p));
}

// Axios sets `error.request` but no `error.response` when the request never
// reached a server (offline/DNS/timeout) — as opposed to a 4xx/5xx, which
// has a response and should NOT be treated as "still offline".
export function isNetworkError(error) {
  return !error.response && !!error.request;
}

export function enqueue(url, method, body) {
  const queue = readQueue();
  queue.push({
    id: Date.now() + "-" + Math.random().toString(36).slice(2),
    url,
    method,
    body,
    ts: Date.now(),
  });
  writeQueue(queue);
}

export function queueLength() {
  return readQueue().length;
}

export function queuedMessage(res, onlineMessage) {
  return res && res.data && res.data.queued
    ? "Saved offline — will sync when reconnected"
    : onlineMessage;
}

let flushing = false;
export async function flushQueue(apiInstance) {
  if (flushing) return;
  flushing = true;
  try {
    let queue = readQueue();
    while (queue.length > 0) {
      const item = queue[0];
      try {
        await apiInstance.request({ url: item.url, method: item.method, data: item.body });
        queue = queue.slice(1);
        writeQueue(queue);
      } catch (err) {
        if (isNetworkError(err)) {
          break; // still offline — stop here, retry on the next trigger
        }
        // Server actually rejected it (4xx/5xx) — don't retry forever, surface it instead.
        queue = queue.slice(1);
        writeQueue(queue);
        failureListeners.forEach(fn => fn(item, err));
      }
    }
  } finally {
    flushing = false;
  }
}
